import { render } from "./SearchAndUserInfo.vue?vue&type=template&id=2cd3c731&scoped=true&ts=true"
import script from "./SearchAndUserInfo.vue?vue&type=script&lang=ts"
export * from "./SearchAndUserInfo.vue?vue&type=script&lang=ts"

import "./SearchAndUserInfo.vue?vue&type=style&index=0&id=2cd3c731&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd3c731"]])

export default __exports__